import React from 'react';
import { motion } from 'framer-motion';
import { FaFileContract, FaHome } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import TopBar from '../components/Layout/TopBar';

const CGU = () => {
  return (
    <div className="min-h-screen bg-[#001B56]">
      <TopBar />
      <div className="sticky top-4 z-50 flex flex-col items-center w-full">
        <div className="relative w-[90vw] max-w-2xl">
          <Navbar />
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-[#00238D] shadow-lg p-8 rounded-lg"
        >
          <div className="flex items-center gap-3 mb-8">
            <FaFileContract className="text-3xl text-purple-600" />
            <h1 className="text-3xl font-bold">Conditions Générales d'Utilisation</h1>
          </div>

          <div className="prose max-w-none">
            <div className="bg-purple-50 border border-purple-200 rounded-lg p-6 mb-8">
              <p className="text-purple-700">
                En utilisant le site web de l'EFAFC, vous acceptez de respecter les présentes conditions générales d'utilisation.
                Veuillez les lire attentivement.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">1. Objet</h2>
            <p className="mb-6">
              Les présentes conditions générales d'utilisation (CGU) ont pour objet de définir les modalités et conditions 
              d'utilisation du site web de l'Entente Feignies Aulnoye Football Club (EFAFC) ainsi que les droits et obligations 
              des utilisateurs.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">2. Acceptation des conditions</h2>
            <p className="mb-6">
              L'accès et l'utilisation du site impliquent l'acceptation pleine et entière des présentes CGU. 
              Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser le site.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">3. Description du service</h2>
            <div className="mb-6">
              <p className="mb-4">Le site EFAFC propose les services suivants :</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Informations sur le club et ses équipes</li>
                <li>Statistiques et résultats des matchs</li>
                <li>Fan Zone avec jeux et activités interactives</li>
                <li>Boutique en ligne pour les produits du club</li>
                <li>Galerie photos et vidéos</li>
                <li>Mur des supporters pour les échanges communautaires</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">4. Compte utilisateur</h2>
            <div className="mb-6">
              <h3 className="text-lg font-bold mb-3">4.1 Création de compte</h3>
              <p className="mb-4">
                Pour accéder à certaines fonctionnalités, vous devez créer un compte utilisateur. 
                Vous vous engagez à fournir des informations exactes et à maintenir ces informations à jour.
              </p>
              
              <h3 className="text-lg font-bold mb-3">4.2 Sécurité du compte</h3>
              <p className="mb-4">
                Vous êtes responsable de la confidentialité de votre mot de passe et de toutes les activités 
                effectuées sous votre compte. Vous devez nous informer immédiatement de toute utilisation non autorisée.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">5. Utilisation du site</h2>
            <div className="mb-6">
              <h3 className="text-lg font-bold mb-3">5.1 Utilisation autorisée</h3>
              <p className="mb-4">
                Vous pouvez utiliser le site uniquement à des fins légales et conformément aux présentes CGU.
              </p>
              
              <h3 className="text-lg font-bold mb-3">5.2 Interdictions</h3>
              <p className="mb-4">Il est strictement interdit de :</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Publier du contenu illégal, offensant, diffamatoire ou inapproprié</li>
                <li>Utiliser le site à des fins commerciales non autorisées</li>
                <li>Tenter de pirater ou d'endommager le site</li>
                <li>Créer de faux comptes ou usurper l'identité d'autrui</li>
                <li>Spammer ou envoyer des messages non sollicités</li>
                <li>Violer les droits de propriété intellectuelle</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">6. Contenu utilisateur</h2>
            <div className="mb-6">
              <p className="mb-4">
                En publiant du contenu sur le site (messages, photos, commentaires), vous accordez à l'EFAFC 
                une licence non exclusive pour utiliser, reproduire et diffuser ce contenu sur le site.
              </p>
              <p className="mb-4">
                Vous restez propriétaire de votre contenu et pouvez le supprimer à tout moment. 
                Vous garantissez que votre contenu ne viole aucun droit de tiers.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">7. Modération</h2>
            <p className="mb-6">
              L'EFAFC se réserve le droit de modérer, supprimer ou refuser tout contenu qui ne respecterait pas 
              les présentes CGU ou qui serait jugé inapproprié. La modération peut être effectuée a priori ou a posteriori.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">8. Propriété intellectuelle</h2>
            <p className="mb-6">
              Tous les éléments du site (textes, images, logos, etc.) sont protégés par les droits de propriété intellectuelle. 
              Toute reproduction ou utilisation non autorisée est interdite.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">9. Disponibilité du service</h2>
            <p className="mb-6">
              Nous nous efforçons de maintenir le site accessible 24h/24 et 7j/7, mais ne pouvons garantir 
              une disponibilité continue. Le site peut être temporairement indisponible pour maintenance ou en cas de force majeure.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">10. Limitation de responsabilité</h2>
            <div className="mb-6">
              <p className="mb-4">L'EFAFC ne peut être tenue responsable :</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Des dommages directs ou indirects résultant de l'utilisation du site</li>
                <li>De la perte de données ou d'informations</li>
                <li>Des interruptions de service</li>
                <li>Du contenu publié par les utilisateurs</li>
                <li>Des liens vers des sites tiers</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">11. Sanctions</h2>
            <div className="mb-6">
              <p className="mb-4">En cas de non-respect des présentes CGU, l'EFAFC peut :</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Supprimer le contenu en violation</li>
                <li>Suspendre temporairement l'accès au compte</li>
                <li>Supprimer définitivement le compte utilisateur</li>
                <li>Prendre toute mesure légale appropriée</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">12. Boutique en ligne</h2>
            <div className="mb-6">
              <p className="mb-4">
                La boutique propose des produits officiels du club. Les commandes sont soumises aux conditions suivantes :
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Les prix sont indiqués en euros TTC</li>
                <li>Les commandes sont confirmées après paiement</li>
                <li>Les délais de livraison sont communiqués lors de la commande</li>
                <li>Le droit de rétractation s'applique selon la législation en vigueur</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">13. Modification des CGU</h2>
            <p className="mb-6">
              L'EFAFC se réserve le droit de modifier les présentes CGU à tout moment. 
              Les utilisateurs seront informés des modifications importantes par email ou notification sur le site.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">14. Droit applicable et juridiction</h2>
            <p className="mb-6">
              Les présentes CGU sont soumises au droit français. 
              En cas de litige, les tribunaux français seront seuls compétents.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">15. Contact</h2>
            <div className="bg-[#001B56] border border-blue-200 rounded-lg p-6 mb-6">
              <p className="mb-4">
                Pour toute question relative aux présentes CGU, contactez-nous :
              </p>
              <ul className="space-y-2">
                <li><strong>Email :</strong> contact@efafc.fr</li>
                <li><strong>Adresse :</strong> [Adresse du club]</li>
              </ul>
            </div>

            <p className="text-sm text-white italic">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <FaHome />
              Retour à l'accueil
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CGU;